var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVaultInactiveNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7931_1850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 10.8307C4.16699 10.3887 4.34259 9.96478 4.65515 9.65222C4.96771 9.33966 5.39163 9.16406 5.83366 9.16406H14.167C14.609 9.16406 15.0329 9.33966 15.3455 9.65222C15.6581 9.96478 15.8337 10.3887 15.8337 10.8307V15.8307C15.8337 16.2728 15.6581 16.6967 15.3455 17.0092C15.0329 17.3218 14.609 17.4974 14.167 17.4974H5.83366C5.39163 17.4974 4.96771 17.3218 4.65515 17.0092C4.34259 16.6967 4.16699 16.2728 4.16699 15.8307V10.8307Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 13.3333C9.16699 13.5543 9.25479 13.7663 9.41107 13.9226C9.56735 14.0789 9.77931 14.1667 10.0003 14.1667C10.2213 14.1667 10.4333 14.0789 10.5896 13.9226C10.7459 13.7663 10.8337 13.5543 10.8337 13.3333C10.8337 13.1123 10.7459 12.9004 10.5896 12.7441C10.4333 12.5878 10.2213 12.5 10.0003 12.5C9.77931 12.5 9.56735 12.5878 9.41107 12.7441C9.25479 12.9004 9.16699 13.1123 9.16699 13.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 9.16667V5.83333C6.66699 4.94928 7.01818 4.10143 7.6433 3.47631C8.26842 2.85119 9.11627 2.5 10.0003 2.5C10.8844 2.5 11.7322 2.85119 12.3573 3.47631C12.9825 4.10143 13.3337 4.94928 13.3337 5.83333V9.16667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7931_1850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultInactiveNew);
export default __webpack_public_path__ + "static/media/vaultInactiveNew.f3b499f289dc0b24b8925543ec842180.svg";
export { ForwardRef as ReactComponent };